// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1fKJu","footer":"ReportModalFilter_footer__2gNVF"};